import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 4em;
  background-color: ${props => props.theme.fundoMenu};
  -webkit-box-shadow: 0px 0px 11px -2px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 11px -2px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 11px -2px rgba(0,0,0,0.75);

  display: flex;
  align-items: center;

  z-index: 50 !important;

  p {
    flex: 1;
  }

  button {
    background: none; /* Remove o fundo */
    border: none;     /* Remove a borda */
    padding: 0;       /* Remove o preenchimento interno */
    margin: 0;        /* Remove qualquer margem extra */
    outline: none;    /* Remove a borda de foco padrão (se necessário) */
    cursor: pointer;  /* Mantém o cursor de ponteiro para indicar que é clicável */
    margin-right: 16px;

    svg {
      font-size: 36px;
      color: ${(props => props.theme.textoMenu)};
      cursor: pointer;

      z-index: 40 !important;

      transition: color 0.3s;

      &:hover {
        color: ${props => props.theme.textoMenuHover};
      }

      &:active {
        color: ${props => props.theme.fundoMenu};
      }
    }
  }

  
`;


export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 84px; /* Ajuste para acomodar o texto */
  height: 36px;
  /* background: ${(props) => (props.theme.mode === 'dark' ? '#000' : '#FFF')}; */
  background: ${(props) => props.theme.fundoToggleTema};
  border-radius: 20px;
  position: relative;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  border: 2px solid ${props => props.theme.toggleTema};
  transition: all 0.4s ease;

  /* Suaviza a borda adicionando um box-shadow sutil */
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 0 5px rgba(255, 165, 0, 0.5);
  }
  margin-right: 20px;
`;

export const ToggleCircle = styled.div`
  width: 32px;
  height: 32px;
  background: ${props => props.theme.toggleTema};
  border-radius: 50%;
  position: absolute;
  left: ${(props) => (props.theme.mode === 'dark' ? '0px' : '48px')}; /* Movimento suave */
  transition: all 0.5s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3); /* Adiciona sombra ao círculo */
`;

export const ToggleText = styled.span`
  /* color: ${(props) => (props.theme.mode === 'dark' ? '#FFF' : '#000')}; */
  color: ${props => props.theme.toggleTema};
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  left: ${(props) => (props.theme.mode === 'dark' ? '40px' : '10px')}; /* Posição dinâmica */
  transition: all 0.4s ease;
`;